@if (lockedState) {
  <div class="full-screen no-events warn"></div>
  <div class="lock-circle no-events">
    <mat-icon class="lock-icon" aria-hidden="false" aria-label="Project locked" fontIcon="lock" matTooltip="Project is currently locked for editing"></mat-icon>
  </div>
}